import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { blueGrey } from '@material-ui/core/colors';
import CustomButton from './CustomButton';
import AnchorLink from 'react-anchor-link-smooth-scroll';


// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function ForumHistory() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            過去の例会講師と演題
          </Typography>
          　デーリー東北政経懇話会では多様な分野と多彩な講師を招いたタイムリーな講演を開催しています。近年の例会の講演テーマと講師（肩書きは講演当時）などは次の通りです。入会を検討する際の参考になれば幸いです。<br/>
          　デーリー東北政経懇話会では、少子高齢化と子育て、自然と環境問題、国際金融経済情勢、投資と資産運用、国内自給率が問題になっている農業・漁業・食糧などの第一次産業のほか犯罪の急増と検挙率の低下など社会問題化している防犯や犯罪心理など社会の関心の高い時局に沿ったテーマで講演を開催していく予定です。ご期待ください。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={1} container direction="row" justify="left">
              <Grid item xs={12} md={4}>
                <AnchorLink href="#kokunai-seiji" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    国内政治
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#kokusai-anzen" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    国際問題・安全保障
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#zeisei-nenkin" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    税制・年金
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#kokunai-keizai" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    国内経済
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#keiei-koyou" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    企業経営・雇用
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#marketing" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    マーケティング
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#tihou-bunken" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    地方分権
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#tiiki-kasseika" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    地域活性化
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#bouhan-hanzai" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    防犯・犯罪心理
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#kenkou" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    健康
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#sports" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    スポーツ
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#shakai-bunka" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    社会・文化
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#geinou-talent" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    芸能・タレント
                  </CustomButton>
                </AnchorLink>
              </Grid>
              <Grid item xs={12} md={4}>
                <AnchorLink href="#saigai-kishou" offset="50">
                  <CustomButton className="d-block w-100" size="large" themeColor={blueGrey}>
                    災害・気象
                  </CustomButton>
                </AnchorLink>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Paper className="p-3 fs90 my-3" id="kokunai-seiji">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">国内政治</Typography>
            <dl>
              <dt>2024年07月01日</dt>
              <dd>「参院選後の激動の政局を展望する」鮫島　浩 氏（政治ジャーナリスト）</dd>
              <dt>2024年02月20日</dt>
              <dd>「自民党派閥の政治資金パーティー裏金事件の背景や今後の混とんとした政局の行方など」岩井　奉信 氏（日本大学名誉教授）</dd>
              <dt>2022年12月13日</dt>
              <dd>「令和４年を振り返り『新たな希望』を考える」大島　理森 氏（前衆院議長）</dd>
              <dt>2022年07月25日</dt>
              <dd>「ロシアのウクライナ侵攻から考える日本の安全保障政策」柳澤　協二 氏（ＮＰＯ法人国際地政学研究所理事長）</dd>
              <dt>2022年04月20日</dt>
              <dd>「大島理森とその時代」本田　雅俊 氏（金城大学客員教授、政治行政アナリスト）</dd>
              <dt>2021年10月26日</dt>
              <dd>「日本人の『政治ぎらい』と若者の社会運動」富永　京子氏 氏（立命館大学産業社会学部准教授）</dd>
              <dt>2021年7月20日</dt>
              <dd>「菅政権の課題と日本政治の行方」伊藤　惇夫 氏（政治アナリスト）</dd>
              <dt>2020年12月22日</dt>
              <dd>「2021年の政局展望」本田 雅俊 氏（金城大学特任教授・政治行政アナリスト）</dd>
              <dt>2019年9月10日</dt>
              <dd>「安倍政権と日本政治の展望」中北　浩爾 氏（一橋大学大学院社会学研究科教授）</dd>
              <dt>2019年4月17日</dt>
              <dd>「日本政治の行方-統一地方選と今後」谷藤　悦史 氏（早稲田大学政治経済学術院教授）</dd>
              <dt>2018年10月22日</dt>
              <dd>「憲法を守るのは誰か～『改憲』の論点」青井　未帆 氏（学習院大学法科大学院教授）</dd>
              <dt>2017年9月19日</dt>
              <dd>「どうなる日本〜混迷する政局の行方」有馬　晴海 氏（政治評論家）</dd>
              <dt>2017年2月20日</dt>
              <dd>「トランプ大統領と日米関係」会田　弘継 氏（共同通信社客員論説委員・青山学院大教授）</dd>
              <dt>2015年4月27日</dt>
              <dd>「夏の政治決戦を読む」伊藤　惇夫 氏（政治アナリスト）</dd>
              <dt>2015年1月26日</dt>
              <dd>「どうなる日本？　安倍政権の課題と展望」有馬　晴海 氏（政治評論家）</dd>
              <dt>2014年9月12日</dt>
              <dd>「安倍政権の評価と行方」本田　雅俊氏（金城大学特任教授・政治行政アナリスト）</dd>
              <dt>2013年7月23日</dt>
              <dd>「参院選後の安倍政権の政策展望」高野　　孟氏（｢インサイダー｣編集長）</dd>
              <dt>2013年4月22日</dt>
              <dd>「憲法と議会制度」只野　雅人氏（一橋大学大学院法学研究科教授）</dd>
              <dt>2012年9月14日</dt>
              <dd>「日本の政治・政局の課題と行方」川村　晃司氏（テレビ朝日コメンテーター）</dd>
              <dt>2012年8月23日</dt>
              <dd>「民主党政権の課題と今後の国内政治」谷藤　悦史氏（早稲田大学政治経済学術院教授）</dd>
              <dt>2011年8月15日</dt>
              <dd>「大震災後の政治を問う」西川　孝純氏（共同通信社特別編集委員）</dd>
              <dt>2011年1月23日</dt>
              <dd>「２０１１年の政局展望」歳川　隆雄氏（インサイドライン編集長）</dd>
              <dt>2010年7月15日</dt>
              <dd>「民主党政権に対する評価」岸　博幸氏（慶應義塾大学大学院教授）</dd>
              <dt>2010年3月16日</dt>
              <dd>「難題抱える鳩山政権と参院選の行方」川上　高志氏（共同通信社論説委員）</dd>
              <dt>2009年8月28日</dt>
              <dd>「政権選択選挙と日本政治の将来」野中　尚人氏（学習院大学教授）</dd>
              <dt>2009年7月17日</dt>
              <dd>「『乱世』に突入した日本政治―その先に何が見えるのか―」伊藤　惇夫氏（政治アナリスト）</dd>
              <dt>2009年3月12日</dt>
              <dd>「衆院解散・総選挙の行方を占う」西川　孝純氏（共同通信社論説委員長）</dd>
              <dt>2008年10月17日</dt>
              <dd>「麻生政権と波乱含みの政局」谷藤　悦史氏（早稲田大学政治経済学部教授）</dd>
              <dt>2008年7月10日</dt>
              <dd>「ねじれ国会と衆院選の行方」梅野　修氏（共同通信社政治部長）</dd>
              <dt>2008年1月17日</dt>
              <dd>「08年政局と衆院選を占う」西川　孝純氏（共同通信社論説委員長）</dd>
              <dt>2007年9月13日</dt>
              <dd>「安倍首相の辞任と政局のゆくえ」歳川　隆雄氏（インサイドライン編集長）</dd>
              <dt>2007年7月26日</dt>
              <dd>「参院選の展望と日本政治の未来」伊藤　惇夫氏（政治アナリスト）</dd>
              <dt>2007年4月18日</dt>
              <dd>「天下分け目の参院選〜各党の思惑は」有馬　晴海氏（政治評論家）</dd>
              <dt>2006年9月13日</dt>
              <dd>「総裁選から参院選への行方」河崎　曽一郎氏（政治ジャーナリスト）</dd>
              <dt>2006年4月17日</dt>
              <dd>「皇室問題の深層を読む」原　武史氏（明治学院大学国際学部教授）</dd>
              <dt>2006年1月19日</dt>
              <dd>「「ポスト小泉」政局の行方」井芹　浩文氏（共同通信論説委員長）</dd>
              <dt>2005年10月18日</dt>
              <dd>「総選挙後の政局　改革の行方」二木　啓孝氏（日刊現代ニュース編集部長）</dd>
              <dt>2005年1月18日</dt>
              <dd>「混迷深める手詰まり政治〜背水の陣敷く小泉首相」田島　良雄氏（政治ジャーナリスト）</dd>
              <dt>2004年12月2日</dt>
              <dd>「政局この一年、来年は？」三反園　訓氏（テレビ朝日コメンテーター）</dd>
              <dt>2004年10月13日</dt>
              <dd>「風吹くか、政局秋の陣」谷藤　悦史氏（早稲田大学教授）</dd>
              <dt>2004年6月16日</dt>
              <dd>「激動の2004年　政局を読む」福岡　政行（白鴎大学教授、立命館大学客員教授）</dd>
              <dt>2004年1月20日</dt>
              <dd>「政局展望と参院選の焦点」河崎曽一郎（政治ジャーナリスト、元NHK解説委員）</dd>
              <dt>2003年9月8日</dt>
              <dd>「自民党総裁選と解散・総選挙の行方」吉田　文和氏（共同通信社政治部次長）</dd>
              <dt>2003年7月14日</dt>
              <dd>「日本政治の現状と課題」蒲島　郁夫氏（東京大学法学部教授）</dd>
              <dt>2003年4月17日</dt>
              <dd>「最近の政治と経済」田中　秀征氏（元経済企画庁長官、福山大学教授）</dd>
              <dt>2002年10月7日</dt>
              <dd>「どうなる小泉政権のゆくえ」高野　孟氏（インサイダー代表取締役兼編集長）</dd>
              <dt>2002年7月8日</dt>
              <dd>「打てるか？　解散・総選挙」河崎　曽一郎氏（政治ジャーナリスト、元NHK解説委員）</dd>
              <dt>2002年4月16日</dt>
              <dd>「小泉改革と混迷する政局」福岡　政行氏（白鴎大学教授）</dd>
              <dt>2002年1月18日</dt>
              <dd>「どうなる小泉改革とこれからの政局」岩井　奉信氏（日本大学教授）</dd>
              <dt>2001年8月10日</dt>
              <dd>「参院選挙の結果と今後の政局」福山　正喜氏（共同通信社政治部長）</dd>
              <dt>2001年4月19日</dt>
              <dd>「新政権の誕生と参院選にかけての動向」矢野　絢也氏（政治評論家）</dd>
              <dt>2001年2月16日</dt>
              <dd>「森政権のゆくえと２００１年の政治展望」谷藤　悦史氏（早稲田大学教授）</dd>
              <dt>2000年10月</dt>
              <dd>「臨時国会と森政権のゆくえ」後藤　謙次氏（共同通信論説委員）</dd>
              <dt>2000年7月13日</dt>
              <dd>「総選挙後の政局展望」高橋　誠氏（政治ジャーナリスト）</dd>
              <dt>2000年3月21日</dt>
              <dd>「小渕連立政権と衆院解散・総選挙」歳川　隆雄氏（インサイドライン編集長）</dd>
              <dt>2000年1月11日</dt>
              <dd>「今後の政局を占う」中村　慶一郎氏（政治評論家）</dd>
              <dt>1999年9月24日</dt>
              <dd>「自自公連立と今後の政局」福岡　政行氏（白鴎大学教授）</dd>
              <dt>1999年4月22日</dt>
              <dd>「自自連立政権の現状と政局」国正　武重氏（政治評論家）</dd>
              <dt>1999年1月21日</dt>
              <dd>「正念場の小渕政権〜自自連立は成功するか」高橋　誠氏（政治ジャーナリスト）</dd>
              <dt>1998年10月23日</dt>
              <dd>「小渕政権と波乱含みの政局」福岡　政行氏（白鴎大学教授）</dd>
              <dt>1998年7月17日</dt>
              <dd>「参院選後の政局を読む」森田　実氏（政治評論家）</dd>
              <dd>「1998年の政局展望」梶原　武俊氏（政治ジャーナリスト・元共同通信社）</dd>
              <dt>1997年9月16日</dt>
              <dd>「臨時国会と今後の政局」福岡　政行氏（白鴎大学教授）</dd>
              <dt>1997年1月23日</dt>
              <dd>「今年の政局を占う」国正　武重氏（政治評論家）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="kokusai-anzen">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">国際問題・安全保障</Typography>
            <dl>
              <dt>2026年04月23日</dt>
              <dd>「世界を揺るがすトランプ政権・高市政権はどう対処するべきか」増田　剛 氏（外交ジャーナリスト・元NHKワシントン特派員）</dd>
              <dt>2024年4月26日</dt>
              <dd>「米大統領選の展望」海野　素央氏（明治大学政治経済学部教授、心理学博士）</dd>
              <dt>2023年4月20日</dt>
              <dd>「緊迫する朝鮮半島と日韓関係の今後」平井　久志氏（共同通信客員論説委員）</dd>
              <dt>2022年9月30日</dt>
              <dd>「脱炭素社会に向けて、いま私たちにできること」堅達（げんだつ）　京子氏（ＮＨＫエンタープライズ　エグゼクティブ・プロデューサー）</dd>
              <dt>2018年7月23日</dt>
              <dd>「トランプ米政権と世界・日本」会田　弘継氏（青山学院大教授、共同通信客員論説委員）</dd>
              <dt>2018年4月17日</dt>
              <dd>「『夢と絆』〜拉致が奪い去ったもの」蓮池　薫氏（拉致被害者）</dd>
              <dt>2017年7月25日</dt>
              <dd>「韓国新政権と日韓関係の行方」李　鍾元氏（早稲田大学大学院アジア太平洋研究科教授）</dd>
              <dt>2015年7月21日</dt>
              <dd>「海洋国家日本と海上自衛隊の活動」真殿　知彦氏（海上自衛隊第２航空群＝八戸市＝司令）</dd>
              <dt>2015年4月24日</dt>
              <dd>「日本人がテロの標的に―世界の脅威、イスラム国の実態」佐々木　伸氏（共同通信客員論説委員）</dd>
              <dt>2014年3月25日</dt>
              <dd>「今後の金正恩体制と日韓朝関係」辺　真一氏（コリア・レポート編集長）</dd>
              <dt>2012年4月17日</dt>
              <dd>「北朝鮮・金正恩体制を読む」礒崎　敦仁氏（慶應義塾大学法学部専任講師）</dd>
              <dt>2011年4月22日</dt>
              <dd>「アラブの大変動を読む〜最近の中東情勢」酒井　啓子氏（東京外国語大学大学院地域文化研究科教授）</dd>
              <dt>2011年2月23日</dt>
              <dd>「中国〜巨大国家を読み解く」興梠　一郎氏（神田外語大学外国語学部教授）</dd>
              <dt>2010年10月26日</dt>
              <dd>「金正日体制と北朝鮮の現状」辺　真一氏（コリア・レポート編集長）</dd>
              <dt>2010年1月22日</dt>
              <dd>「温室効果ガス排出90年対比25％削減の衝撃」足達　英一郎氏(日本総合研究所主席研究員)</dd>
              <dt>2009年4月17日</dt>
              <dd>「新局面を迎えた北朝鮮情勢」辺　真一（ピョン・ジンイル）氏(コリア・レポート編集長)</dd>
              <dt>2008年4月22日</dt>
              <dd>「中国の食品安全問題と今後の経済動向」杜　進氏（拓殖大学国際学部教授）</dd>
              <dt>2007年1月19日</dt>
              <dd>「米中間選挙のアジアへの影響」渡部　恒雄氏(三井物産戦略研究所国際情報部主任研究員)</dd>
              <dt>2006年7月18日</dt>
              <dd>「米国の世界戦略と日本の安全保障」小川　和久氏（国際政治・軍事アナリスト）</dd>
              <dt>2006年3月28日</dt>
              <dd>「朝鮮半島情勢を読む〜核・拉致・歴史問題〜」李　　鍾元氏（立教大学法学部教授）</dd>
              <dt>2005年7月19日</dt>
              <dd>「東アジアの諸情勢と日本の安全保障」西元　徹也氏（元防衛庁統合幕僚会議議長）</dd>
              <dt>2004年8月27日</dt>
              <dd>「最近の中国経済と日本企業の中国ビジネス展開」菅野　真一郎氏（みずほコーポレート銀行顧問）</dd>
              <dt>2004年4月22日</dt>
              <dd>「最近の朝鮮半島情勢と日本」伊豆見　元氏（静岡県立大学国際関係学部教授）</dd>
              <dt>2004年3月26日</dt>
              <dd>「自衛隊海外派遣とイラクの行方」水口　章氏（敬愛大学国際学部助教授、前中東調査会上席研究員）</dd>
              <dt>2003年8月4日</dt>
              <dd>「北朝鮮　核・拉致問題の行方」辺　真一氏（コリア・レポート編集長）</dd>
              <dt>2003年1月17日</dt>
              <dd>「2003年の日本と国際情勢のゆくえ」歳川　隆雄氏（「インサイドライン」編集長）</dd>
              <dt>2002年9月12日</dt>
              <dd>「揺れ動く国際情勢と日本の危機管理」志方　俊之氏（帝京大学教授、元陸自北部方面総監）</dd>
              <dt>2000年4月18日</dt>
              <dd>「ロシア新大統領と今後の日ロ関係」小林　和男氏（NHK解説主幹）</dd>
              <dt>1999年12月9日・特別例会</dt>
              <dd>「最近のニュースから」蓮　舫氏（キャスター）</dd>
              <dt>1997年4月16日</dt>
              <dd>「香港返還とこれからの中国」朱　建栄氏（東洋学園大学教授）</dd>
              <dt>1997年3月17日</dt>
              <dd>「行政改革と日本の危機管理」小川　和久氏（国際政治・軍事アナリスト）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="zeisei-nenkin">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">税制・年金</Typography>
            <dl>
              <dt>2015年10月26日</dt>
              <dd>「マイナンバーで何が変わるか」中島　洋氏（日本個人情報管理協会理事長）</dd>
              <dt>2013年6月13日</dt>
              <dd>「消費税８％は怖くない」野田　美和子氏（税理士）</dd>
              <dt>2011年10月21日</dt>
              <dd>「豊かなセカンドライフを送るために」和泉　昭子氏（生活経済ジャーナリスト）</dd>
              <dt>2005年9月9日</dt>
              <dd>「相続と代替わり−相続時精算課税と事業承継」入江　範子氏（税理士・元築館税務署長）</dd>
              <dt>2004年7月15日</dt>
              <dd>「少子高齢化と年金の将来」袖井　孝子氏（お茶の水女子大学大学院客員教授）</dd>
              <dt>1999年6月18日</dt>
              <dd>「熟年世代の人生を楽しむヒント」木村　陽子氏（奈良女子大助教授）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="kokunai-keizai">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">国内経済</Typography>
            <dl>
              <dt>2025年1月23日</dt>
              <dd>「２０２５年の経済展望」藤代　宏一氏（第一生命経済研究所経済調査部主席エコノミスト）</dd>
              <dt>2023年6月15日</dt>
              <dd>「『どんがら』とエンジニア仕事術」清武　英利氏（ノンフィクション作家）</dd>
              <dt>2023年1月31日</dt>
              <dd>「２０２３年の経済展望」小林　真一郎氏（三菱ＵＦＪリサーチ＆コンサルティング主席研究員）</dd>
              <dt>2022年1月25日</dt>
              <dd>「２０２２年の経済展望」神田　慶司氏（大和総研経済調査部日本経済調査課長、シニアエコノミスト）</dd>
              <dt>2021年4月19日</dt>
              <dd>「未来の地域金融」橋本　卓典氏（共同通信社編集委員）</dd>
              <dt>2020年1月22日</dt>
              <dd>「２０２０年経済展望～消費税から米為替報告書まで～」岩本　沙弓氏（経済評論家）</dd>
              <dt>2019年1月17日</dt>
              <dd>「2019年の経済展望　近づく内外景気の転換点」早川　英男氏（富士通総研経済研究所エグゼクティブ・フェロー）</dd>
              <dt>2018年6月28日</dt>
              <dd>「世界に誇れる日本の美点〜インバウンドビジネスで日本的グローバル化〜」ルース・マリー・ジャーマン氏（ジャーマン・インターナショナルＣＥＯ）</dd>
              <dt>2018年3月26日</dt>
              <dd>「株・為替の現状と将来の有望市場」古市　庸治氏（野村證券投資情報部グローバル・チャート・アナリスト）</dd>
              <dt>2018年1月23日</dt>
              <dd>「２０１８年経済展望〜どうなる世界・日本・地方」伊藤　さゆり氏（ニッセイ基礎研究所主席研究員）</dd>
              <dt>2017年1月19日</dt>
              <dd>「人口２／３激減時代の到来と『新』成長戦略―都市を測る、都市を活（い）かす」和田　理都子氏（野村證券（株）金融公共公益法人部・主任研究員）</dd>
              <dt>2016年3月22日</dt>
              <dd>「ＴＰＰとこれからの地域経済〜農業、観光こそリーディングインダストリー」郭　洋春（かく・やんちゅん）氏（立教大経済学部教授）</dd>
              <dt>2016年2月23日</dt>
              <dd>「北海道新幹線開業後の八戸」梅原　淳氏（鉄道ジャーナリスト）</dd>
              <dt>2016年1月18日</dt>
              <dd>「2016年の経済展望」岩本沙弓氏（大阪経済大学経営学部客員教授）</dd>
              <dt>2015年3月26日</dt>
              <dd>「どうなる？来年度の日本経済！」永濱　利廣氏（第一生命経済研究所経済調査部主席エコノミスト）</dd>
              <dt>2014年5月24日</dt>
              <dd>「震災後の日本経済の行方」熊野　英生氏（第一生命経済研究所首席エコノミスト）</dd>
              <dt>2014年4月22日</dt>
              <dd>「震災復興―地震災害に強い経済・社会の構築」佐藤　主光氏（一橋大学政策大学院教授）</dd>
              <dt>2013年8月21日</dt>
              <dd>「アベノミクスと日本の政治経済の課題」加藤　創太氏（国際大学教授）</dd>
              <dt>2013年3月22日</dt>
              <dd>「震災後のエネルギー展望」高木　雄次氏（笹川平和財団理事長）</dd>
              <dt>2012年2月18日</dt>
              <dd>「２０１３年の内外経済展望」吉崎　達彦氏（双日総合研究所副所長）</dd>
              <dt>2012年1月24日</dt>
              <dd>「日本経済はどこへ行くのか」中島　隆信氏（慶應義塾大学商学部教授）</dd>
              <dt>2011年5月24日</dt>
              <dd>「震災後の日本経済の行方」熊野　英生氏（第一生命経済研究所首席エコノミスト）</dd>
              <dt>2010年2月26日</dt>
              <dd>「日本経済これからのシナリオ」浜　矩子氏（同志社ビジネススクール教授）</dd>
              <dt>2009年2月16日</dt>
              <dd>「どうなる　これからの日本と世界経済」大西　良雄氏（経済ジャーナリスト）</dd>
              <dt>2008年8月29日</dt>
              <dd>「ワーキングプアの問題とその解決策」門倉　貴史氏（ＢＲＩＣｓ経済研究所代表）</dd>
              <dt>2007年12月6日</dt>
              <dd>「食品の安全・安心最前線・日本と世界の食料情勢」中村　隆司氏（日清製粉取締役社長＝八戸市出身）</dd>
              <dt>2007年8月23日</dt>
              <dd>「格差社会とセーフティネット」唐鎌　直義氏（専修大学経済学部教授）</dd>
              <dt>2006年2月15日</dt>
              <dd>「日本経済これからのシナリオ」浜　矩子氏（同志社ビジネススクール教授）</dd>
              <dt>2006年2月14日</dt>
              <dd>「日本経済の近未来図〜バブル前夜と20年前との類似性〜」熊野　英生氏（第一生命経済研究所主席エコノミスト）</dd>
              <dt>2005年8月10日</dt>
              <dd>「団塊世代の攻略法」井徳　正吾氏（博報堂DYメディアパートナーズ・メディア情報開発部長）</dd>
              <dt>2005年6月9日・特別例会</dt>
              <dd>「ストックとフロー」内川　晋氏（関東自動車工業会長）</dd>
              <dt>2004年2月20日</dt>
              <dd>「デフレは終わった　日本経済の今後はどうなる」塚崎　公義氏（財団法人国際金融センター調査企画部長）</dd>
              <dt>2003年10月23日</dt>
              <dd>「日本経済これからのシナリオ」浜　矩子氏（同志社大学マネージメントスクール教授）</dd>
              <dt>2003年2月14日</dt>
              <dd>「03日本経済のあすを読む〜景気と経済再生の行方」水城　武彦氏（NHK解説委員）</dd>
              <dt>2002年8月9日</dt>
              <dd>「中小企業・地域経済は構造改革にどう立ち向かうべきか」益田　安良氏（東洋大学教授、元富士総研主席研究員）</dd>
              <dt>2002年2月26日</dt>
              <dd>「どうなる２００２年の日本経済」霧島　和孝氏（住友生命総合研究所定石主任研究員）</dd>
              <dt>2001年9月13日</dt>
              <dd>「大変革期の日本経済〜いまをどう乗り切るか」田嶋　智太郎氏（金融・経済ジャーナリスト）</dd>
              <dt>2001年1月23日</dt>
              <dd>「日本経済、これからどうなる」新保　恵志氏（東海大学教養学部教授）</dd>
              <dt>2000年9月</dt>
              <dd>「地域から変える日本の経済」竹内　佐和子氏（東京大学助教授）</dd>
              <dt>2000年2月18日</dt>
              <dd>「倒産急増と企業の危機管理」熊谷　勝行氏（帝国データバンク情報部長）</dd>
              <dt>1999年10月22日</dt>
              <dd>「日本経済、本当はどうなのか」高橋　伸彰氏（立命館大学教授）</dd>
              <dt>1998年3月19日</dt>
              <dd>「経済危機と官僚の腐敗」塩田　潮氏（作家・評論家）</dd>
              <dt>1998年2月24日</dt>
              <dd>「浮上するか、これからの日本経済」勝又嘉良氏（東海大学教授）</dd>
              <dt>1997年7月22日</dt>
              <dd>「大転換期を迎えた日本経済と株式市場」田嶋　智太郎（経済ジャーナリスト）</dd>
              <dt>1997年2月21日</dt>
              <dd>「日本経済はよみがえるか」高橋　伸彰氏（日本開発銀行主任研究員）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="keiei-koyou">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">企業経営・雇用</Typography>
            <dl>
              <dt>2024年8月21日</dt>
              <dd>「親不孝介護で離職を防ぐ！～経営者・自治体が取り組むべきこととは？～」川内潤 氏（ＮＰＯ法人「となりのかいご」代表理事）</dd>
              <dt>2023年12月5日</dt>
              <dd>「人を動かす世界最高の話し方」岡本純子 氏（コミュニケーション戦略研究家、株式会社グローコム代表取締役社長）</dd>
              <dt>2022年8月30日</dt>
              <dd>「ポストコロナ時代の働き方が地方を変える」浜田敬子氏（ジャーナリスト）</dd>
              <dt>2021年5月13日</dt>
              <dd>「社員が第一 〜元気な組織づくり」小島俊一氏（元気ファクトリー（愛媛県松山市）代表取締役）</dd>
              <dt>2019年10月16日</dt>
              <dd>「働きやすくなる発想法　若者パワーを活かすコミュニケーション」関沢英彦氏（東京経済大名誉教授）</dd>
              <dt>2019年3月20日</dt>
              <dd>「定年後を見据えた働き方改革」楠木新氏（作家、神戸松蔭女子学院大学教授）</dd>
              <dt>2018年12月4日</dt>
              <dd>「メジャーリーグに学ぶビジネス成功術～勝つための組織と人の活かし方」タック川本氏（国際ビジネス＆スポーツアナリスト）</dd>
              <dt>2015年6月23日</dt>
              <dd>「銀座のママに学ぶ“一流の”人間力、ビジネス力」白坂　亜紀氏（銀座社交料飲協会理事・株式会社白坂企画代表取締役）</dd>
              <dt>2014年8月19日</dt>
              <dd>「社員の成長は企業の成長―社員のモチベーションを高める経営」近藤　宣之氏（株式会社日本レーザー代表取締役社長）</dd>
              <dt>2009年9月11日</dt>
              <dd>「元気な企業〜秘訣はここに」崎山　嗣夫氏（マーケッティングコンサルタント）</dd>
              <dt>2008年3月11日</dt>
              <dd>「たかがビール　されどビール〜アサヒスーパードライの成功事例に学ぶ」松井　康雄氏（元アサヒビール・マーケティング部長）</dd>
              <dt>2006年10月20日</dt>
              <dd>「社長を出せ！〜クレーム最前線と企業の危機管理」川田　茂雄氏（クレーム処理研究会主宰）</dd>
              <dt>2002年6月19日・特別例会</dt>
              <dd>「ベンチャーな日々〜そうじをビジネスに」沖　幸子氏（フラオ　グルッペ（株）取締役社長・生活評論家）</dd>
              <dt>1999年7月23日</dt>
              <dd>「不況下、売り上げを伸ばすコツはこれだ」岩井　義照氏（祝経営研究所長）</dd>
              <dt>1999年2月18日</dt>
              <dd>「流通が変える街づくり」野口　智雄氏（早稲田大学教授）</dd>
              <dt>1998年8月21日</dt>
              <dd>「景気動向と企業経営〜誤った認識から脱却しよう」古川　英夫氏（経営コンサルタント）</dd>
              <dt>1997年10月20日</dt>
              <dd>「ベンチャービジネス成功の経営哲学」澤村　経夫氏（日本アルミット社長）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="marketing">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">マーケティング</Typography>
            <dl>
              <dt>2019年6月19日</dt>
              <dd>「第一印象で差をつける外見力マネジメント」唐澤　理恵氏（パーソナルデザイン社長）</dd>
              <dt>2016年10月25日</dt>
              <dd>「国際規格の大改正でこれからの世の中はこう変わる」泉山　　博氏（泉コンサルティング代表）</dd>
              <dt>2013年10月22日</dt>
              <dd>「新しい時代のマーケティング戦略」井上　哲浩氏（慶應義塾大学大学院経営管理研究科教授）</dd>
              <dt>2011年7月15日</dt>
              <dd>「日本の漁業と水産加工業の行方」小松　正之氏（政策研究大学院教授）</dd>
              <dt>2010年4月27日</dt>
              <dd>「ビジネスに活かす色彩戦略」木下　代理子氏（カラーカウンセラー、色彩研究家）</dd>
              <dt>2001年3月13日</dt>
              <dd>「新幹線開通と地域開発」山口　貴久男氏（生活行動研究所代表取締役）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="tihou-bunken">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">地方分権</Typography>
            <dl>
              <dt>2010年9月10日</dt>
              <dd>「まちが魅力を取り戻すとき」中沢　孝夫氏（福井県立大学特任教授）</dd>
              <dt>2004年9月14日</dt>
              <dd>「市町村合併の現状と今後の課題」横道　清孝氏（政策研究大学院大学教授）</dd>
              <dt>2002年3月15日</dt>
              <dd>「市町村合併と地方自治」横道　清孝氏（政策研究大学院大学教授）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="tiiki-kasseika">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">地域活性化</Typography>
            <dl>
              <dt>2025年3月26日</dt>
              <dd>「これからの地方創生　〜持続可能な地域づくりを展望する」坂本誠氏（公益財団法人地方自治総合研究所常任研究員）</dd>
              <dt>2024年6月26日</dt>
              <dd>「八戸から世界へ！世界から八戸へ！　多世代×多文化×多言語『まんまるシティ八戸』を目指して」上斗米正子氏（一般財団法人言語交流研究所研究員・ヒッポファミリークラブフェロー）</dd>
              <dt>2023年9月21日</dt>
              <dd>「釣り・漁業×地域活性の可能性」中川めぐみ氏（株式会社ウオー代表取締役）</dd>
              <dt>2023年2月27日</dt>
              <dd>「回復へ動き出したコロナ禍４年目の地方観光」鳥海高太朗氏（航空・旅行アナリスト）</dd>
              <dt>2021年11月22日</dt>
              <dd>「食で地方はよみがえる　～コロナを超えて」奥田政行氏（イタリア料理店「アル・ケッチァーノ」オーナーシェフ）</dd>
              <dt>2021年1月20日</dt>
              <dd>「『出会いと学びのアートファーム』アートのまちづくりと八戸市新美術館」小林眞氏（八戸市長）</dd>
              <dt>2019年12月10日</dt>
              <dd>「世界視点からの地域社会の未来」大谷真樹氏（インフィニティ国際学院学院長）</dd>
              <dt>2016年7月27日</dt>
              <dd>「外国人が喜ぶオ・モ・テ・ナ・シ」クリス・グレン氏（ラジオＤＪ、タレント）</dd>
              <dt>2016年2月23日</dt>
              <dd>「北海道新幹線開業後の八戸」梅原　淳氏（鉄道ジャーナリスト）</dd>
              <dt>2014年7月24日</dt>
              <dd>「北東北の観光・地域活性化への提言」清水　愼一氏（観光地域づくりプラットフォーム推進機構会長）</dd>
              <dt>2013年9月19日</dt>
              <dd>「台湾とより交流を深めるために」原田　武彦氏（元中央発條社長）</dd>
              <dt>2009年1月23日</dt>
              <dd>「地方を元気に！　政治経済の混乱を超えて」増田　寛也氏（元総務大臣、元岩手県知事）</dd>
              <dt>2008年9月12日</dt>
              <dd>「水産物ブランドと地域活性化」小松　正之氏（政策研究大学院大学教授）</dd>
              <dt>2003年12月2日・特別例会</dt>
              <dd>「左手にソロバン　右手に人情」冨永　照子氏（全国商店街おかみさん会会長）</dd>
              <dt>2001年10月18日</dt>
              <dd>「観光と地域振興」前田　勇氏（立教大学大学院観光学研究科教授）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="bouhan-hanzai">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">防犯・犯罪心理</Typography>
            <dl>
              <dt>2026年9月16日</dt>
              <dd>「敵を知る　 ～フロンティアAIが変えるサイバー攻撃と防御の最前線」増田　幸美氏（日本プルーフポイント（株）チーフエバンジェリスト）</dd>
            </dl>
            <dl>
              <dt>1999年3月19日</dt>
              <dd>「世紀末の犯罪〜取材ノートから」二木　啓孝氏（日刊現代ニュース編集部長）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="kenkou">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">健康</Typography>
            <dl>
              <dt>2025年10月30日</dt>
              <dd>「健康長寿のために今からできること － 血糖値から学ぶ健康の新常識」山村　聡氏（やさしい内科クリニック院長）</dd>
              <dt>2023年10月30日</dt>
              <dd>「笑いと健康」大西　金吾氏（新潟県労働衛生医学協会常勤顧問）</dd>
              <dt>2022年10月20日</dt>
              <dd>「重粒子線がん治療　～がん治療の新たな選択～」根本　建二氏（山形大学理事・副学長）</dd>
              <dt>2022年2月24日</dt>
              <dd>「コロナ禍の健康管理と笑いの効果～こころとからだを癒す笑いの力～」大平　哲也氏（福島県立医科大学疫学講座主任教授）</dd>
              <dt>2021年3月15日</dt>
              <dd>「寒さと生きる菌類～雪腐病（ゆきぐされびょう）から味噌（みそ）玉まで」星野　保氏（八戸工業大工学部生命環境科学科教授）</dd>
              <dt>2020年11月25日</dt>
              <dd>「コロナとインフルエンザ～感染症の正しい知識とその予防策」岩崎　恵美子氏（健康予防政策機構代表、医師）</dd>
              <dt>2017年12月7日</dt>
              <dd>「熟年離婚と夫源病（ふげんびょう）〜男と女、心地よい距離を保つには」石蔵　文信氏（大阪大招へい教授、医師）</dd>
              <dt>2016年8月25日</dt>
              <dd>「ガッテン流！生活常識、大逆転のススメ」北折　一氏（元ＮＨＫ科学・環境番組部専任ディレクター）</dd>
              <dt>2016年6月27日</dt>
              <dd>「経営者のためのスマートエイジング指南」宮田　恵氏（医師、シニア野菜ソムリエ）</dd>
              <dt>2015年12月10日</dt>
              <dd>「ぐっすり眠る３０の方法」三橋　美穂氏（セラピスト、睡眠環境プランナー）</dd>
              <dt>2011年12月6日</dt>
              <dd>「今の日本に必要な身体をつくる食べもの」安井　レイコ氏（料理研究家）</dd>
              <dt>2009年10月22日</dt>
              <dd>「脳を若く保って長生きする方法」米山　公啓氏（医師・作家）</dd>
              <dt>2009年6月4日</dt>
              <dd>「男の食学（たべがく）とメタボリックシンドローム」荒牧　麻子氏（食卓プロデューサー）</dd>
              <dt>2008年12月7日</dt>
              <dd>「現代に活かす戦国武将の健康力」植田　美津江氏（医学ジャーナリスト、医学博士）</dd>
              <dt>2008年2月14日</dt>
              <dd>「老いと介護と人生と」久田　恵氏（ノンフィクション作家）</dd>
              <dt>2007年12月5日</dt>
              <dd>「食品の安全・安心最前線・日本と世界の食糧情勢」中村　隆司氏（日清製粉取締役社長）</dd>
              <dt>2007年6月19日</dt>
              <dd>「笑いの効用…明るいコミュニケーション」大島　希巳江氏（文京学院大学准教授）</dd>
              <dt>2007年3月15日</dt>
              <dd>「これだけ知っていれば安心―最新の感染症対策―」野田　公俊氏（千葉大学大学院医学研究院病原分子制御学教授）</dd>
              <dt>2006年12月5日</dt>
              <dd>「ストレス社会を生き抜く脳をつくる」高田　明和氏（浜松医科大学名誉教授）</dd>
              <dt>2003年3月3日</dt>
              <dd>「医食同源―いかに食べ、いかに飲むか」佐藤　信紘氏（順天堂大学医学部付属病院副院長）</dd>
              <dt>1999年8月20日</dt>
              <dd>「これで安心　あなたの健康」富家　孝氏（医師、医療ジャーナリスト）</dd>
              <dt>1998年12月11日・特別例会</dt>
              <dd>「おいしく食べて健康に」岸　朝子氏（食生活ジャーナリスト）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="sports">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">スポーツ</Typography>
            <dl>
              <dt>2026年6月11日</dt>
              <dd>「相撲王国青森県復活に向けて」荒井　太郎 氏（相撲ジャーナリスト）</dd>
              <dt>2024年7月25日</dt>
              <dd>「知っておくと楽しい　パリ五輪」佐野　慎輔 氏（尚美学園大学スポーツマネジメント学部教授、笹川スポーツ財団理事・上席特別研究員）</dd>
              <dt>2024年3月22日</dt>
              <dd>「２０２４年シーズンに活躍が期待される日本人メジャーリーガーの展望など」石原　秀知 氏（共同通信社スポーツデータ部長）</dd>
              <dt>2020年10月26日</dt>
              <dd>「スポーツの力で青森の可能性を創造する」荒川 栄 氏（青森山田高校男子新体操部監督）</dd>
              <dt>2020年2月13日</dt>
              <dd>「迫る東京五輪・パラリンピック～見どころ・課題・レガシー」名取　裕樹 氏（共同通信社オリンピック・パラリンピック室長）</dd>
              <dt>2019年7月18日</dt>
              <dd>「アスリートは大地が作る～2020東京に世界がやってくる」谷藤　悦史 氏（早稲田大学政治経済学術院教授）</dd>
              <dt>2016年9月26日</dt>
              <dd>「リオ経由トーキョー〜オリンピックの今」山本　浩 氏（元ＮＨＫアナウンサー、法政大教授）</dd>
              <dt>2015年8月25日</dt>
              <dd>「２０２０年東京オリンピック・パラリンピックの期待と課題」島村　俊治 氏（スポーツジャーナリスト）</dd>
              <dt>2014年12月4日</dt>
              <dd>「一流とはなにか〜アスリートたちの真実」小松　成美 氏（兵庫県立大客員教授）</dd>
              <dt>2013年1月24日</dt>
              <dd>「野球が私に教えてくれたこと」山中　正竹氏（法政大学特任教授）</dd>
              <dt>2011年6月22日</dt>
              <dd>「スポーツ放送５０年の楽しさ」西田　善夫氏（スポーツアナリスト、元ＮＨＫ解説委員、アナウンサー）</dd>
              <dt>2008年6月5日</dt>
              <dd>「プロ野球監督に学ぶ人の育て方、使い方」野崎　靖博氏（スポーツジャーナリスト、元日刊スポーツ新聞社編集委員）</dd>
              <dt>2002年12月9日・特別例会</dt>
              <dd>「スポーツが面白くなる見方」西田　善夫氏（元NHK解説委員、前横浜国際総合競技場長）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="shakai-bunka">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">社会・文化</Typography>
            <dl>
              <dt>2026年7月59日</dt>
              <dd>「ツキノワグマの生態と地域ぐるみの被害防除－岩手県のある集落のチャレンジ」青井俊樹 氏（岩手大学名誉教授）</dd>
              <dt>2023年8月23日</dt>
              <dd>「科学捜査と捜査支援～回顧と展望」服藤恵三 氏（医学博士、最高検察庁参与）</dd>
              <dt>2023年7月25日</dt>
              <dd>「ChatGPTの仕組み～活用事例と今後の展開」島内宏和 氏（八戸工業大学准教授）</dd>
              <dt>2023年3月27日</dt>
              <dd>「日本語の変化とつきあうコツ」飯間浩明 氏（日本語学者・国語辞典編さん者）</dd>
              <dt>2021年12月21日</dt>
              <dd>「withコロナ社会の見取り図 ～ウイルスとの共生の視点から」山本　太郎 氏（長崎大学熱帯医学研究所教授）</dd>
              <dt>2021年6月22日</dt>
              <dd>「日本麦酒産業史　～ビールがもっとおいしくなる話、あります」端田（はしだ）　晶氏（作家・ビール文化研究家）</dd>
              <dt>2020年2月17日</dt>
              <dd>「『北海道・北東北の縄文遺跡群』世界文化遺産登録への期待」岡田　康博 氏（青森県世界文化遺産登録推進室長）</dd>
              <dt>2019年2月18日</dt>
              <dd>「平成の天皇のあゆみと皇室の課題」河西　秀哉 氏（名古屋大学大学院人文学研究科准教授）</dd>
              <dt>2018年8月20日</dt>
              <dd>「会社が変わる！　かたづけの力」小松 易 氏（スッキリ・ラボ代表、日本初の“かたづけ士”）</dd>
              <dt>2018年2月26日</dt>
              <dd>「大相撲と行司の世界」第３６代木村庄之助氏（元立行司）</dd>
              <dt>2017年10月23日</dt>
              <dd>「私が会った日本映画の名優たち―三國連太郎、高倉健、渥美清、吉永小百合さんら」立花　珠樹氏（共同通信社編集委員）</dd>
              <dt>2017年8月22日</dt>
              <dd>「世界は数学でできている〜知的エンターテインメントを楽しもう」桜井　進氏（サイエンスナビゲーター）</dd>
              <dt>2017年6月26日</dt>
              <dd>「大事なことから忘れなさい〜迷える心に効く三十の禅の教え〜」松山　大耕 氏（京都市・妙心寺退蔵院副住職）</dd>
              <dt>2017年4月17日</dt>
              <dd>「陛下のお気持ち〜生前退位が及ぼす影響」山下　晋司 氏（皇室ジャーナリスト）</dd>
              <dt>2014年10月22日</dt>
              <dd>「ロボカップ＠ホーム　人とロボットが共存する社会を目指して」岡田　浩之 氏（玉川大学脳科学研究所応用脳科学研究センター教授）</dd>
              <dt>2014年1月24日</dt>
              <dd>「コミュニケーション―心と心の繋（つな）ぎ方」松富かおり氏（コミュニケーションアドバイザー）</dd>
              <dt>2013年12月5日</dt>
              <dd>「これまでの映像メディアとその方向」今井　環氏（ＮＨＫエンタープライズ代表取締役社長）</dd>
              <dt>2012年12月4日</dt>
              <dd>「草食系男子は内向きなのか〜名付け親が語るイマドキ若者論」深澤真紀氏（コラムニスト・編集者）</dd>
              <dt>2010年12月3日</dt>
              <dd>「龍馬とその時代〜時代考証の立場から」大石　学氏（東京学芸大学教授）</dd>
              <dt>2010年8月20日</dt>
              <dd>「電気自動車と太陽光発電による『燃やさない文明』の提言」村沢　義久氏（東京大学総長室アドバイザー）</dd>
              <dt>2006年10月20日</dt>
              <dd>「社長を出せ！〜クレーム最前線と企業の危機管理」川田　茂雄氏（クレーム処理研究会主宰）</dd>
              <dt>2006年8月8日</dt>
              <dd>「知っておきたい裁判員制度〜もしもあなたが選ばれたら」畑野　隆二氏（法務省刑事局総務課裁判員制度啓発推進室長）</dd>
              <dt>2001年6月28日・特別例会</dt>
              <dd>「色の不思議―似合う色で得をする方法」大平　雅美氏（アナウンサー、カラーコーディネーター）</dd>
              <dt>2000年12月7日・特別例会</dt>
              <dd>「競争社会の楽しみ方」吉永　みち子（ノンフィクション作家）</dd>
              <dt>1998年9月18日</dt>
              <dd>「企業今昔物語〜最新社内事情」大山　真人（ノンフィクション作家）</dd>
              <dt>1998年6月19日・特別例会</dt>
              <dd>「できる男は女を活かす」藤田　桂子氏（(株)フジタス社長）</dd>
              <dt>1998年4月20日</dt>
              <dd>「明治維新を支えた人物に学ぶ」加来　耕三氏（歴史作家）</dd>
              <dt>1997年12月16日・特別例会</dt>
              <dd>「人生の主役　それはあなた」長田　渚左氏（ノンフィクション作家）</dd>
              <dt>1997年8月28日</dt>
              <dd>「私と息子とボランティア」中田　武仁氏（国連ボランティア名誉大使）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="geinou-talent">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">芸能・タレント</Typography>
            <dl>
              <dt>2024年12月16日</dt>
              <dd>「努力は夢をかなえてくれる」蝶花楼　桃花氏（落語家）</dd>
              <dt>2018年9月25日</dt>
              <dd>「歌舞伎十八番と成田屋」織田　紘二氏（日本芸術文化振興会（国立劇場）顧問）</dd>
              <dt>2016年12月5日</dt>
              <dd>「主婦からシャンソン歌手に〜３９歳からの出発」川上　順子氏（シャンソン歌手）</dd>
              <dt>2015年2月23日</dt>
              <dd>「今の人生よりワンランク・アップする質問会話術」水島　裕氏（声優、ナレーター、タレント）</dd>
              <dt>2014年6月12日</dt>
              <dd>「落語家が語る笑いの世界のイマ」川柳　つくし氏（落語家）</dd>
              <dt>2012年6月15日</dt>
              <dd>「だめんずとの恋愛」倉田真由美氏（マンガ家）</dd>
              <dt>2010年6月4日</dt>
              <dd>「であいふれあいひびきあい〜『のど自慢』」12年の旅から」宮川　泰夫氏（元ＮＨＫアナウンサー）</dd>
              <dt>2009年12月10日</dt>
              <dd>「寄席演芸『講談』の世界に入って」日向　ひまわり氏（講談師）</dd>
              <dt>2006年6月13日</dt>
              <dd>「喜寿を迎えて　芸の進化と健康の秘密」田辺　一鶴氏（講談師）</dd>
              <dt>1999年3月19日</dt>
              <dd>「世紀末の犯罪〜取材ノートから」二木　啓孝氏（日刊現代ニュース編集部長）</dd>
            </dl>
          </Paper>

          <Paper className="p-3 fs90 my-3" id="saigai-kishou">
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">災害・気象</Typography>
            <dl>
              <dt>2021年8月25日</dt>
              <dd>「東北地方太平洋沖地震から10年～海底地殻変動の研究から分かってきたこと」日野　亮太氏（東北大学大学院理学研究科教授）</dd>
              <dt>2019年8月21日</dt>
              <dd>「青森県太平洋沖の巨大地震と津波」岡村　行信氏（産業技術総合研究所活断層・火山専門部門特命上席研究員）</dd>
              <dt>2015年9月28日</dt>
              <dd>「新しい地震予測への取り組みと実績」村井　俊治氏（東京大名誉教授）</dd>
              <dt>2007年10月19日</dt>
              <dd>「気象と私たちの暮らし〜農業からビジネスへのかかわり」斎藤　義雄氏（気象予報士、防災士）</dd>
              <dt>2005年12月9日</dt>
              <dd>「人間だけが平等に尊いのではありません」赤松　光真師（延暦寺釈迦堂輪番兼居士林所長）</dd>
              <dt>2005年2月17日</dt>
              <dd>「地球温暖化と異常気象」住　明正氏（東京大学気候システム研究センター教授）</dd>
              <dt>2001年7月19日</dt>
              <dd>「大地震あなたは大丈夫か」伊藤和明氏（元NHK解説委員）</dd>
            </dl>
          </Paper>
        </Box>
      </div>
    </div>
  );
}

export default ForumHistory;
